<template>
  <div
    class="flex justify-between p-3 border-2 rounded-xl mt-4 border-success border-solid text-link h-4p5"
  >
    <div class="flex space-x-4">
      <div class="relative">
        <img v-if="this.previewImage" :src="this.previewImage" class="w-10" />
        <div
          class="absolute bottom-check right-check rounded-full bg-neutral-white p-1p5"
        >
          <check class="h-3 text-success" />
        </div>
      </div>
      <div class="flex items-center text-14">
        <div>
          {{ name }}
        </div>
        <div class="text-12"></div>
      </div>
    </div>
    <div v-if="showButtons" class="flex items-center justify-center pr-4">
      <circle-button
        class="flex items-center justify-center w-8 h-8 mr-4  bg-secondary-200 hover:bg-primary-200 hover:text-primary focus-visible:ring"
        @click="$emit('edit')"
      >
        <pencil-outlined class="h-3"></pencil-outlined>
      </circle-button>
      <circle-button
        class="flex items-center justify-center w-8 h-8  bg-secondary-200 hover:bg-primary-200 hover:text-primary focus-visible:ring"
        @click="$emit('delete')"
      >
        <times class="h-3"></times>
      </circle-button>
    </div>
  </div>
</template>

<script>
import CircleButton from "@/components/General/CircleButton.vue";
import PencilOutlined from "@/assets/pencil-outlined.svg";
import Check from "@/assets/check.svg";
import Times from "@/assets/times.svg";
export default {
  name: "UploaderSuccess",
  props: {
    name: {
      type: String,
    },
    previewImage: {
      type: String,
    },
    showButtons: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    CircleButton,
    PencilOutlined,
    Times,
    Check,
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/tailwind.scss";
</style>
